const PILL_BG = 'hsl(224, 25%, 12%)';
const PILL_TEXT = 'var(--color-greyscale-25)';
const BADGE_BG = 'var(--color-primary-500)';
const HOVER_BG = 'rgba(255, 255, 255, 0.1)';
const DIVIDER = 'rgba(255, 255, 255, 0.15)';

export const verticalDividerSx = { width: '1px', bgcolor: DIVIDER, my: 0.75 };
export const pillButtonSx = {
  height: 32,
  px: 1.25,
  minWidth: 0,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: 12,
  fontWeight: 500,
  color: PILL_TEXT,
  '& .MuiButton-startIcon': { mr: 0.75, '& svg': { fontSize: 16 } },
  '&:hover': { bgcolor: HOVER_BG },
  '&.Mui-disabled': { color: 'rgba(255,255,255,0.6)' },
};
export const loadingIconSx = { color: 'inherit' };
export const actionCountSx = {
  ml: 0.75,
  fontSize: 10,
  fontFamily: 'monospace',
  fontVariantNumeric: 'tabular-nums',
  opacity: 0.6,
};
export const pillPositionSx = {
  position: 'fixed',
  bottom: 24,
  transform: 'translateX(-50%)',
  zIndex: 1250,
};
export const pillContainerSx = {
  px: 1,
  py: 0.5,
  borderRadius: '14px',
  bgcolor: PILL_BG,
  color: PILL_TEXT,
  boxShadow: '0 12px 32px rgba(0, 0, 0, 0.35)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  animation: 'bulkPillIn 200ms cubic-bezier(0.16, 1, 0.3, 1)',
  '@keyframes bulkPillIn': {
    from: { opacity: 0, transform: 'translateY(12px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
};
export const selectedCountContainerSx = { pl: 1, pr: 1.5, borderRight: `1px solid ${DIVIDER}` };
export const selectedCountBadgeSx = {
  width: 20,
  height: 20,
  borderRadius: '6px',
  bgcolor: BADGE_BG,
  color: 'var(--color-white)',
  display: 'grid',
  placeItems: 'center',
  fontSize: 11,
  fontWeight: 600,
};
export const selectedCountTextSx = { fontSize: 12, color: PILL_TEXT, whiteSpace: 'nowrap' };
export const closeButtonSx = {
  width: 32,
  height: 32,
  borderRadius: '8px',
  color: PILL_TEXT,
  '&:hover': { bgcolor: HOVER_BG },
};
export const closeIconSx = { fontSize: 16 };
